module.exports = __webpack_public_path__ + "static/media/LANDMARKS-ID-Logo-no-strap.cec86131.svg";